class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this._onToggleClick = this._onToggleClick.bind(this);
    this._onOverlayClick = this._onOverlayClick.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
    this._onResize = this._onResize.bind(this);
    this._onCartClick = this._onCartClick.bind(this);
  }

  connectedCallback() {
    // overlay
    this.overlay = document.querySelector(".menu-overlay");
    if (!this.overlay) {
      this.overlay = document.createElement("div");
      this.overlay.className = "menu-overlay";
      this.overlay.hidden = true;
      document.body.appendChild(this.overlay);
    }

    // toggle button that controls this drawer
    this.toggleBtn = document.querySelector(
      `[data-menu-toggle][aria-controls="${this.id}"]`,
    );

    if (this.toggleBtn) {
      this.iconHamburger = this.toggleBtn.querySelector(
        "[data-icon-hamburger]",
      );
      this.iconClose = this.toggleBtn.querySelector("[data-icon-close]");
      this.toggleBtn.addEventListener("click", this._onToggleClick);
    }

    // cart button closes drawer
    this.cartBtn = document.querySelector("[data-el-cart-open]");
    if (this.cartBtn) {
      this.cartBtn.addEventListener("click", this._onCartClick, true);
      // `true` (capture) helps ensure we close first even if cart logic runs too
    }

    this.overlay.addEventListener("click", this._onOverlayClick);
    document.addEventListener("keydown", this._onKeydown);
    window.addEventListener("resize", this._onResize);

    this._setHeaderHeightVar();

    // optional: click any link inside drawer closes it
    this.addEventListener("click", (e) => {
      const link = e.target.closest("a");
      if (link) this.close();
    });

    // accessibility default
    if (!this.hasAttribute("aria-hidden"))
      this.setAttribute("aria-hidden", "true");
  }

  disconnectedCallback() {
    if (this.toggleBtn)
      this.toggleBtn.removeEventListener("click", this._onToggleClick);
    if (this.cartBtn)
      this.cartBtn.removeEventListener("click", this._onCartClick, true);
    if (this.overlay)
      this.overlay.removeEventListener("click", this._onOverlayClick);
    document.removeEventListener("keydown", this._onKeydown);
    window.removeEventListener("resize", this._onResize);
  }

  _setHeaderHeightVar() {
    const header = document.querySelector("[data-header-wrapper]");
    if (!header) return;
    const h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty("--header-height", `${h}px`);
  }

  open() {
    this._setHeaderHeightVar();

    this.setAttribute("open", "");
    this.setAttribute("aria-hidden", "false");

    this.overlay.hidden = false;
    document.body.classList.add("menu-open");

    if (this.toggleBtn) this.toggleBtn.setAttribute("aria-expanded", "true");
    if (this.iconHamburger) this.iconHamburger.hidden = true;
    if (this.iconClose) this.iconClose.hidden = false;
  }

  close() {
    this.removeAttribute("open");
    this.setAttribute("aria-hidden", "true");

    this.overlay.hidden = true;
    document.body.classList.remove("menu-open");

    if (this.toggleBtn) this.toggleBtn.setAttribute("aria-expanded", "false");
    if (this.iconHamburger) this.iconHamburger.hidden = false;
    if (this.iconClose) this.iconClose.hidden = true;
  }

  toggle() {
    this.hasAttribute("open") ? this.close() : this.open();
  }

  _onToggleClick() {
    this.toggle();
  }

  _onOverlayClick() {
    this.close();
  }

  _onKeydown(e) {
    if (e.key === "Escape" && this.hasAttribute("open")) this.close();
  }

  _onResize() {
    if (this.hasAttribute("open")) this._setHeaderHeightVar();
  }

  _onCartClick() {
    // If menu is open, close it when cart is clicked
    if (this.hasAttribute("open")) this.close();
  }
}

customElements.define("menu-drawer", MenuDrawer);
